/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-unstable-nested-components */
import React, { useState } from 'react';
import { Search, Table } from 'src/components';
import { Button, Paper } from '@mui/material';
import { AddUserIcon, EditIcon } from 'src/icons';
import { createColumnHelper } from '@tanstack/react-table';
import { RowHover } from 'src/components/Table';
import debounce from 'src/utils/Debounce';
import { Currency } from 'src/hooks/query/currencies/types';
import { CurrenciesViewRendererProps } from '../../types';

interface ActionDivProps {
  onEdit: (data: Currency) => void;
  info: Currency;
}

const ActionDiv = function ActionDiv(actionProps: ActionDivProps) {
  const { onEdit, info } = actionProps;
  return (
    <div className="flex flex-row justify-center items-center gap-2">
      <div onClick={() => onEdit(info)}>
        <EditIcon />
      </div>
    </div>
  );
};

function Desktop(props: CurrenciesViewRendererProps) {
  const {
    currenciesFetching,
    filterCurrencies,
    showCreateCurrency,
    onEditRow,
    onChange,
  } = props;

  const debouncedSearch = debounce(onChange, 100);
  const columnHelper = createColumnHelper<Currency>();
  const [rowHover, setRowHover] = useState<RowHover>({});

  const columns = [
    columnHelper.accessor('id', {
      header: () => '',
      cell: () => <div className="px-2" />,
    }),
    columnHelper.accessor('id', {
      header: () => 'S.No',
      cell: (info) => (info.row.index + 1),
    }),
    columnHelper.accessor('code', {
      header: () => 'Code',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('symbol', {
      header: () => 'Symbol',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('name', {
      header: () => 'Name',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('status', {
      header: () => 'Status',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('id', {
      header: () => '',
      cell: (info) => (
        <div className="flex justify-center items-center min-w-[100px] min-h-[40px]">
          {
            rowHover[info.row.index]
            && (
              <ActionDiv
                info={info.row.original}
                onEdit={onEditRow}
              />
            )
          }
        </div>
      ),
    }),
  ];

  const onRowHover = (data: RowHover) => {
    setRowHover(data);
  };

  const onSearchChange = (data: string) => {
    debouncedSearch(data);
  };

  return (
    <>
      <div className="mt-[2%] flex gap-2 flex-row w-[700px]">
        <Search placeholder="Search" onChange={onSearchChange} />
        <div className="w-[176px]">
          <Button variant="contained" fullWidth startIcon={<AddUserIcon />} className="h-[40px] font-medium whitespace-nowrap" onClick={showCreateCurrency} size="small">Add New Currency</Button>
        </div>
      </div>
      <Paper className="flex items-center justify-center my-[2%] mt-3 default-shadow-table w-[700px]">
        <Table onRowHover={onRowHover} loading={currenciesFetching} data={filterCurrencies} columns={columns} title="List of Currencies" />
      </Paper>
    </>
  );
}

export default Desktop;
